export default {
  computed: {
    getTitleErrorMessage() {
      let errorMessage = '';
      if (!this.$v.title.$error) {
        errorMessage = '';
      } else if (!this.$v.title.required) {
        errorMessage = this.$t('CSAT_MGMT.FORM.TITLE.REQUIRED_ERROR');
      } else if (!this.$v.title.minLength) {
        errorMessage = this.$t('CSAT_MGMT.FORM.TITLE.MINIMUM_LENGTH_ERROR');
      }
      return errorMessage;
    },
    getQuestionsFormErrorMessage() {
      let errorMessage = '';
      if (!this.$v.questions.$error) {
        errorMessage = '';
      } else if (!this.$v.questions.required) {
        errorMessage = this.$t('CSAT_MGMT.FORM.QUESTIONS.REQUIRED_ERROR');
      } else if (!this.$v.questions.validSurveyQuestions) {
        errorMessage = this.$t('CSAT_MGMT.FORM.QUESTIONS.VALIDATION_ERROR');
      }
      return errorMessage;
    },
  },
};
